var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/AttachmentUploader/AnonymousAttachmentUploader.tsx
import * as React6 from "react";
import { classNames, getEdgeNodes as getEdgeNodes3, useFragment as useFragment3 } from "@workflows/runtime-web";
import { Button as Button2, Callout, Label, Stack as Stack3, StackItem as StackItem4, useViewerTenant as useViewerTenant3 } from "@workflows/ui";

// src/AttachmentUploader/hooks/__generated__/useUploadAnonymousAttachmentMutation.graphql.ts
var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadUrl",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientMutationId",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentLength",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confidential",
      "storageKey": null
    },
    v10 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v11 = [{
      "kind": "Literal",
      "name": "first",
      "value": 100
    }],
    v12 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useUploadAnonymousAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v1,
        "concreteType": "UploadAnonymousAttachmentPayload",
        "kind": "LinkedField",
        "name": "uploadAnonymousAttachment",
        "plural": false,
        "selections": [v2, v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, v8, v9, {
            "alias": null,
            "args": null,
            "concreteType": "_User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [v10],
            "storageKey": null
          }, {
            "args": [{
              "kind": "Literal",
              "name": "count",
              "value": 100
            }],
            "kind": "FragmentSpread",
            "name": "AssigneesPreview__node"
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useUploadAnonymousAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v1,
        "concreteType": "UploadAnonymousAttachmentPayload",
        "kind": "LinkedField",
        "name": "uploadAnonymousAttachment",
        "plural": false,
        "selections": [v2, v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, v8, v9, {
            "alias": null,
            "args": null,
            "concreteType": "_User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [v10, v5],
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": "assignees",
              "args": v11,
              "concreteType": "_AssigneeConnection",
              "kind": "LinkedField",
              "name": "_assignees",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_AssigneeConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Assignee",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [v12, v5, v6],
                    "storageKey": null
                  }, v12],
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": "_assignees(first:100)"
            }, {
              "alias": "assignees",
              "args": v11,
              "filters": null,
              "handle": "connection",
              "key": "AssigneesPreview__assignees",
              "kind": "LinkedHandle",
              "name": "_assignees"
            }],
            "type": "_HasAssignees",
            "abstractKey": "__is_HasAssignees"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "filters": null,
          "handle": "appendNode",
          "key": "",
          "kind": "LinkedHandle",
          "name": "attachment",
          "handleArgs": [{
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }, {
            "kind": "Literal",
            "name": "edgeTypeName",
            "value": "AttachmentConnectionEdge"
          }]
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "9f7f842f47fc4833f3c55f38b2167e5e",
      "id": null,
      "metadata": {},
      "name": "useUploadAnonymousAttachmentMutation",
      "operationKind": "mutation",
      "text": "mutation useUploadAnonymousAttachmentMutation(\n  $input: UploadAnonymousAttachmentInput!\n) {\n  uploadAnonymousAttachment(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n    uploadUrl\n    clientMutationId\n    attachment {\n      id\n      name\n      contentLength\n      downloadUrl\n      confidential\n      creator {\n        displayName\n        id\n      }\n      ...AssigneesPreview__node_2ON54F\n    }\n  }\n}\n\nfragment AssigneesPreview__node_2ON54F on _HasAssignees {\n  __is_HasAssignees: __typename\n  assignees: _assignees(first: 100) {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "966d8759958f7611de544b849852b650";
var useUploadAnonymousAttachmentMutation_graphql_default = node;

// src/AttachmentUploader/hooks/useUploadAnonymousAttachment.tsx
import { newId, useMutation, ConnectionHandler } from "@workflows/runtime-web";
import { useViewerTenant } from "@workflows/ui";
var useUploadAnonymousAttachment = () => {
  const {
    tenantId
  } = useViewerTenant(true);
  const [mutation, isPending] = useMutation(uploadAnonymousAttachmentMutation);
  const uploadAnonymousAttachment = props => {
    const {
      onError,
      onCompleted,
      input: {
        refId,
        code,
        confidential,
        name,
        contentLength
      }
    } = props;
    const connectionID = ConnectionHandler.getConnectionID(refId, "useAttachmentsFragment_attachments");
    mutation({
      variables: {
        input: {
          clientMutationId: newId(),
          code,
          confidential,
          contentLength,
          name,
          tenantId,
          refId
        },
        connections: [connectionID]
      },
      onError,
      onCompleted
    });
  };
  return {
    uploadAnonymousAttachment,
    isPending
  };
};
var uploadAnonymousAttachmentMutation = (useUploadAnonymousAttachmentMutation_graphql_default.hash && useUploadAnonymousAttachmentMutation_graphql_default.hash !== "966d8759958f7611de544b849852b650" && console.error("The definition of 'useUploadAnonymousAttachmentMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useUploadAnonymousAttachmentMutation_graphql_default);

// src/AttachmentUploader/AnonymousAttachmentInput.tsx
import axios from "axios";
import { AttachmentInput } from "@workflows/ui";
import * as React from "react";
function AnonymousAttachmentInput({
  refId,
  onUpload,
  isConfidential,
  setErrors,
  setFileState,
  setAttachmentId,
  setProgress,
  code,
  abortControllerRef
}) {
  const {
    uploadAnonymousAttachment
  } = useUploadAnonymousAttachment();
  const handleChange = file => {
    setErrors([]);
    if (!file) {
      return;
    }
    uploadAnonymousAttachment({
      input: {
        refId,
        name: file.name,
        contentLength: file.size,
        confidential: isConfidential,
        code
      },
      onCompleted(data) {
        const {
          uploadAnonymousAttachment: uploadAnonymousAttachment2
        } = data || {};
        const {
          errors,
          uploadUrl,
          attachment
        } = uploadAnonymousAttachment2 || {};
        if (errors && errors.length > 0) {
          console.error(errors);
          setErrors(errors);
          setFileState(void 0);
        }
        if (!uploadUrl) {
          return;
        }
        setAttachmentId(attachment?.id);
        abortControllerRef.current = new AbortController();
        axios.put(uploadUrl, file, {
          headers: {
            "Content-Type": file.type
          },
          onUploadProgress: progressEvent => {
            const {
              loaded,
              total = 1
            } = progressEvent;
            const percentage = Math.floor(loaded * 100 / total);
            setProgress(percentage);
          },
          signal: abortControllerRef.current?.signal
        }).catch(error => {
          if (error.code === "ERR_CANCELED") {
            setFileState(void 0);
          } else {
            console.log(error);
          }
        });
        setFileState({
          name: file.name,
          size: file.size
        });
        onUpload?.(file);
      },
      onError(err) {
        console.log(err);
      }
    });
  };
  return /* @__PURE__ */React.createElement(AttachmentInput, {
    onChange: handleChange
  });
}

// src/AssigneesPreview/__generated__/AssigneesPreview__node.graphql.ts
var node2 = function () {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [{
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }],
    "kind": "Fragment",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["assignees"]
      }]
    },
    "name": "AssigneesPreview__node",
    "selections": [{
      "alias": "assignees",
      "args": null,
      "concreteType": "_AssigneeConnection",
      "kind": "LinkedField",
      "name": "__AssigneesPreview__assignees_connection",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "_AssigneeConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "_Assignee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [v0, {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "actor",
            "plural": false,
            "selections": [v0, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "_HasAssignees",
    "abstractKey": "__is_HasAssignees"
  };
}();
node2.hash = "97ad758a4f1779a9f95145684ed5943a";
var AssigneesPreview_node_graphql_default = node2;

// src/AssigneesPreview/__generated__/AssigneesPreview_node.graphql.ts
var node3 = function () {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [{
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }],
    "kind": "Fragment",
    "metadata": {
      "connection": [{
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": ["assignees"]
      }]
    },
    "name": "AssigneesPreview_node",
    "selections": [{
      "alias": "assignees",
      "args": null,
      "concreteType": "AssigneeConnection",
      "kind": "LinkedField",
      "name": "__AssigneesPreview_assignees_connection",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "AssigneeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "Assignee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [v0, {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "actor",
            "plural": false,
            "selections": [v0, {
              "kind": "InlineFragment",
              "selections": [{
                "alias": "userName",
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }],
              "type": "User",
              "abstractKey": null
            }, {
              "kind": "InlineFragment",
              "selections": [{
                "alias": "groupName",
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }],
              "type": "Group",
              "abstractKey": null
            }],
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "HasAssignees",
    "abstractKey": "__isHasAssignees"
  };
}();
node3.hash = "1fe44dbed921e2c9ed360b1e21163a15";
var AssigneesPreview_node_graphql_default2 = node3;

// src/AssigneesPreview/index.tsx
import { getEdgeNodes, useFragment } from "@workflows/runtime-web";
import * as React2 from "react";
import { Avatars, Row, StackItem, Text, Tooltip } from "@workflows/ui";
function AssigneesPreview({
  node: node12,
  compat = false,
  count = 3,
  ...props
}) {
  const data = useFragment(compat ? AssigneesPreview__node : AssigneesPreview_node, node12);
  const avatars = getEdgeNodes(data.assignees).filter(assignee => !!assignee.actor?.name).map(assignee => ({
    label: assignee.actor?.name
  }));
  const avatarsToPreview = avatars.slice(0, count);
  const avatarsToHide = avatars.slice(count);
  return /* @__PURE__ */React2.createElement(Tooltip, {
    content: /* @__PURE__ */React2.createElement(Avatars, {
      ...props,
      avatars: avatarsToHide
    }),
    placement: "right",
    disabled: avatarsToHide.length === 0
  }, /* @__PURE__ */React2.createElement(Row, {
    align: "center",
    justify: "start",
    gap: "xxs"
  }, /* @__PURE__ */React2.createElement(Avatars, {
    ...props,
    avatars: avatarsToPreview
  }), /* @__PURE__ */React2.createElement(StackItem, null, /* @__PURE__ */React2.createElement(Text, {
    noWrap: true
  }, avatars.length > count && `+ ${avatarsToHide.length}`))));
}
var AssigneesPreview_node = (AssigneesPreview_node_graphql_default2.hash && AssigneesPreview_node_graphql_default2.hash !== "1fe44dbed921e2c9ed360b1e21163a15" && console.error("The definition of 'AssigneesPreview_node' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), AssigneesPreview_node_graphql_default2);
var AssigneesPreview__node = (AssigneesPreview_node_graphql_default.hash && AssigneesPreview_node_graphql_default.hash !== "97ad758a4f1779a9f95145684ed5943a" && console.error("The definition of 'AssigneesPreview__node' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), AssigneesPreview_node_graphql_default);

// src/AttachmentUploader/AttachmentUploaderUpdater.tsx
import { Checkbox, Heading, Row as Row2, Stack, StackItem as StackItem2 } from "@workflows/ui";
import * as React4 from "react";

// src/useUikitTranslation.ts
import { useTranslation } from "react-i18next";

// src/i18n.ts
import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";

// src/locales/en.json
var en_default = {
  AttachmentUploader: {
    error: {
      unspecific: "The upload could not be started. Please try again in a minute.",
      INPUT_TOO_LARGE: "Maximum file size exceeded. The file cannot be larger than 100 MB.",
      INVALID_TYPE: "The type of file you are uploading is not valid.",
      INVALID_INPUT: "The file you are uploading is not valid."
    },
    actions: {
      close: "Close"
    },
    hint: "You can upload images, documents, and audio/video files up to 100 MB per file.",
    confidential: "confidential",
    permissions: "Visibility",
    clear: "Clear",
    assigned: "Assigned",
    searchPlaceholder: "Name",
    searchEmptyLabel: "The person was not found."
  }
};

// src/locales/de.json
var de_default = {
  AttachmentUploader: {
    error: {
      unspecific: "Der Upload konnte nicht gestartet werden. Bitte versuchen Sie es erneut in einer Minute.",
      INPUT_TOO_LARGE: "Maximale Dateigr\xF6\xDFe \xFCberschritten. Die Datei darf nicht gr\xF6\xDFer als 100 MB sein.",
      INVALID_TYPE: "Der Dateityp ist nicht zul\xE4ssig.",
      INVALID_INPUT: "Die Datei ist ung\xFCltig."
    },
    actions: {
      close: "Schlie\xDFen"
    },
    hint: "Sie k\xF6nnen Bilder, Dokumente und Audio-/Videodateien bis zu einer Gr\xF6\xDFe von 100 MB pro Datei anh\xE4ngen.",
    confidential: "Vertraulich",
    permissions: "Sichtbarkeit",
    clear: "Leeren",
    assigned: "Zugewiesen",
    searchPlaceholder: "Name",
    searchEmptyLabel: "Die Person wurde nicht gefunden."
  }
};

// src/i18n.ts
var uikitI18nInstance = createInstance({
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: en_default
    },
    de: {
      translation: de_default
    }
  }
});
uikitI18nInstance.use(initReactI18next).init();

// src/useUikitTranslation.ts
function useUikitTranslation(keyPrefix) {
  return useTranslation("", {
    i18n: uikitI18nInstance,
    keyPrefix
  });
}

// src/AttachmentUploader/AttachmentAssigneePicker.tsx
import * as React3 from "react";

// src/__generated__/useAssignablesFragment.graphql.ts
var node4 = {
  "argumentDefinitions": [{
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refId"
  }, {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refTypeIdentifier"
  }, {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAssignablesFragment",
  "selections": [{
    "alias": "assignables",
    "args": [{
      "kind": "Variable",
      "name": "refId",
      "variableName": "refId"
    }, {
      "kind": "Variable",
      "name": "refTypeIdentifier",
      "variableName": "refTypeIdentifier"
    }, {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }],
    "concreteType": "_AssignableConnection",
    "kind": "LinkedField",
    "name": "_assignables",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "_AssignableConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          }],
          "type": "_User",
          "abstractKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Query",
  "abstractKey": null
};
node4.hash = "09791e786a9c7a7e672b78de6ed8e896";
var useAssignablesFragment_graphql_default = node4;

// src/__generated__/useAssignablesQuery.graphql.ts
var node5 = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "refId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "refTypeIdentifier"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    v3 = [{
      "kind": "Variable",
      "name": "refId",
      "variableName": "refId"
    }, {
      "kind": "Variable",
      "name": "refTypeIdentifier",
      "variableName": "refTypeIdentifier"
    }, {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }],
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "type": "_User",
      "abstractKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0, v1, v2],
      "kind": "Fragment",
      "metadata": null,
      "name": "useAssignablesQuery",
      "selections": [{
        "alias": "assignables",
        "args": v3,
        "concreteType": "_AssignableConnection",
        "kind": "LinkedField",
        "name": "_assignables",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "_AssignableConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v4, v5, v6],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2, v0, v1],
      "kind": "Operation",
      "name": "useAssignablesQuery",
      "selections": [{
        "alias": "assignables",
        "args": v3,
        "concreteType": "_AssignableConnection",
        "kind": "LinkedField",
        "name": "_assignables",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "_AssignableConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }, v4, v5, v6],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "aa425519533f275c52069405cb305c9c",
      "id": null,
      "metadata": {},
      "name": "useAssignablesQuery",
      "operationKind": "query",
      "text": "query useAssignablesQuery(\n  $tenantId: ID!\n  $refId: ID\n  $refTypeIdentifier: String\n) {\n  assignables: _assignables(tenantId: $tenantId, refId: $refId, refTypeIdentifier: $refTypeIdentifier) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        ... on _User {\n          email\n          type\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node5.hash = "7723def1860f0b6c8153266ff6ebd66f";
var useAssignablesQuery_graphql_default = node5;

// src/useAssignables.tsx
import { getEdgeNodes as getEdgeNodes2, useFragment as useFragment2, useLazyLoadQuery } from "@workflows/runtime-web";
import { useTenantId } from "@workflows/ui";
var useAssignables = (tenant, refId, refTypeIdentifier) => {
  const tenantId = useTenantId();
  const {
    assignables
  } = useLazyLoadQuery(assignablesQuery, {
    tenantId: tenant || tenantId,
    refId,
    refTypeIdentifier
  });
  return filterAssignablesWithoutName(getEdgeNodes2(assignables || null));
};
var assignablesQuery = (useAssignablesQuery_graphql_default.hash && useAssignablesQuery_graphql_default.hash !== "7723def1860f0b6c8153266ff6ebd66f" && console.error("The definition of 'useAssignablesQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useAssignablesQuery_graphql_default);
var useAssignablesFragment = queryRef => {
  const {
    assignables
  } = useFragment2(assignablesFragment, queryRef);
  return filterAssignablesWithoutName(getEdgeNodes2(assignables || null));
};
var assignablesFragment = (useAssignablesFragment_graphql_default.hash && useAssignablesFragment_graphql_default.hash !== "09791e786a9c7a7e672b78de6ed8e896" && console.error("The definition of 'useAssignablesFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useAssignablesFragment_graphql_default);
var filterAssignablesWithoutName = assignables => {
  return assignables.filter(assignable => !!assignable.name);
};

// src/AttachmentUploader/AttachmentAssigneePicker.tsx
import { AssigneePicker } from "@workflows/ui";
var AttachmentAssigneePicker = ({
  assignees,
  onChange
}) => {
  const assignables = useAssignables();
  const [pickedAssignees, setPickedAssignees] = React3.useState(assignees.length > 0 ? assignees : []);
  const assignablesWithNames = filterAssignablesWithoutName(assignables);
  function handleAssigneesChange(assignees2) {
    setPickedAssignees(assignees2);
    onChange(assignees2);
  }
  const {
    t
  } = useUikitTranslation("AttachmentUploader");
  return /* @__PURE__ */React3.createElement(AssigneePicker, {
    clearAllLabel: t("clear"),
    onChange: assignees2 => handleAssigneesChange(assignees2),
    role: {
      id: "ai.workflows.roles.role:assignee",
      name: t("assigned")
    },
    searchPlaceholder: t("searchPlaceholder"),
    searchEmptyLabel: t("searchEmptyLabel"),
    users: assignablesWithNames,
    value: pickedAssignees || void 0,
    required: 1,
    iconPos: "start"
  });
};

// src/AttachmentUploader/hooks/__generated__/useUpdateAttachmentMutation.graphql.ts
var node6 = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    v2 = [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }],
    v3 = {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientMutationId",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confidential",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedAt",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    v10 = [v7],
    v11 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v12 = {
      "kind": "InlineFragment",
      "selections": [v7, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textColor",
        "storageKey": null
      }],
      "type": "_Status",
      "abstractKey": null
    },
    v13 = [v11, {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "actor",
        "plural": false,
        "selections": v10,
        "storageKey": null
      }],
      "type": "_Assignee",
      "abstractKey": null
    }, v12],
    v14 = [{
      "kind": "Literal",
      "name": "first",
      "value": 100
    }],
    v15 = [v11, {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "actor",
        "plural": false,
        "selections": [v11, v7, v5],
        "storageKey": null
      }],
      "type": "_Assignee",
      "abstractKey": null
    }, v12, v5];
  return {
    "fragment": {
      "argumentDefinitions": [v0, v1],
      "kind": "Fragment",
      "metadata": null,
      "name": "useUpdateAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v2,
        "concreteType": "UpdateAttachmentPayload",
        "kind": "LinkedField",
        "name": "updateAttachment",
        "plural": false,
        "selections": [v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, {
            "args": [{
              "kind": "Literal",
              "name": "count",
              "value": 100
            }],
            "kind": "FragmentSpread",
            "name": "AssigneesPreview__node"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "refObject",
          "plural": false,
          "selections": [{
            "kind": "InlineFragment",
            "selections": [v5, {
              "alias": null,
              "args": null,
              "concreteType": "_ActivityConnectionType",
              "kind": "LinkedField",
              "name": "_activities",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_ActivityConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Activity",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, v8, v9, {
                    "alias": null,
                    "args": null,
                    "concreteType": "_User",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": v10,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fromObject",
                    "plural": false,
                    "selections": v13,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "toObject",
                    "plural": false,
                    "selections": v13,
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "type": "_Matter",
            "abstractKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1, v0],
      "kind": "Operation",
      "name": "useUpdateAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v2,
        "concreteType": "UpdateAttachmentPayload",
        "kind": "LinkedField",
        "name": "updateAttachment",
        "plural": false,
        "selections": [v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": "assignees",
              "args": v14,
              "concreteType": "_AssigneeConnection",
              "kind": "LinkedField",
              "name": "_assignees",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_AssigneeConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Assignee",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [v11, v5, v7],
                    "storageKey": null
                  }, v11],
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": "_assignees(first:100)"
            }, {
              "alias": "assignees",
              "args": v14,
              "filters": null,
              "handle": "connection",
              "key": "AssigneesPreview__assignees",
              "kind": "LinkedHandle",
              "name": "_assignees"
            }],
            "type": "_HasAssignees",
            "abstractKey": "__is_HasAssignees"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "filters": null,
          "handle": "appendNode",
          "key": "",
          "kind": "LinkedHandle",
          "name": "attachment",
          "handleArgs": [{
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }, {
            "kind": "Literal",
            "name": "edgeTypeName",
            "value": "AttachmentConnectionEdge"
          }]
        }, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "refObject",
          "plural": false,
          "selections": [v11, v5, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "_ActivityConnectionType",
              "kind": "LinkedField",
              "name": "_activities",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_ActivityConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Activity",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, v8, v9, {
                    "alias": null,
                    "args": null,
                    "concreteType": "_User",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [v7, v5],
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fromObject",
                    "plural": false,
                    "selections": v15,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "toObject",
                    "plural": false,
                    "selections": v15,
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "type": "_Matter",
            "abstractKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "7dc8032f92e82d2f2291439be96ee67e",
      "id": null,
      "metadata": {},
      "name": "useUpdateAttachmentMutation",
      "operationKind": "mutation",
      "text": "mutation useUpdateAttachmentMutation(\n  $input: UpdateAttachmentInput!\n) {\n  updateAttachment(input: $input) {\n    errors {\n      code\n      message\n      type\n    }\n    clientMutationId\n    attachment {\n      id\n      confidential\n      name\n      ...AssigneesPreview__node_2ON54F\n    }\n    refObject {\n      __typename\n      ... on _Matter {\n        id\n        _activities {\n          edges {\n            node {\n              id\n              insertedAt\n              identifier\n              actor {\n                name\n                id\n              }\n              fromObject {\n                __typename\n                ... on _Assignee {\n                  actor {\n                    __typename\n                    name\n                    id\n                  }\n                }\n                ... on _Status {\n                  name\n                  color\n                  textColor\n                }\n                id\n              }\n              toObject {\n                __typename\n                ... on _Assignee {\n                  actor {\n                    __typename\n                    name\n                    id\n                  }\n                }\n                ... on _Status {\n                  name\n                  color\n                  textColor\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AssigneesPreview__node_2ON54F on _HasAssignees {\n  __is_HasAssignees: __typename\n  assignees: _assignees(first: 100) {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "312805c734920c11f8bcb04f1e2e7703";
var useUpdateAttachmentMutation_graphql_default = node6;

// src/AttachmentUploader/hooks/useUpdateAttachment.tsx
import { ConnectionHandler as ConnectionHandler2, newId as newId2, useMutation as useMutation2 } from "@workflows/runtime-web";
import { useViewerTenant as useViewerTenant2 } from "@workflows/ui";
function useUpdateAttachment() {
  const {
    tenantId
  } = useViewerTenant2(true);
  const [mutation] = useMutation2(updateAttachmentMutation);
  const updateAttachment = props => {
    const {
      onError,
      onCompleted,
      input: {
        confidential,
        assignees,
        attachmentId,
        name
      },
      refId
    } = props;
    const connectionID = ConnectionHandler2.getConnectionID(refId, "useAttachmentsFragment_attachments");
    mutation({
      variables: {
        input: {
          clientMutationId: newId2(),
          attachmentId,
          tenantId,
          confidential,
          assignees,
          name
        },
        connections: [connectionID]
      },
      onCompleted,
      onError
    });
  };
  return {
    updateAttachment
  };
}
var updateAttachmentMutation = (useUpdateAttachmentMutation_graphql_default.hash && useUpdateAttachmentMutation_graphql_default.hash !== "312805c734920c11f8bcb04f1e2e7703" && console.error("The definition of 'useUpdateAttachmentMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useUpdateAttachmentMutation_graphql_default);

// src/AttachmentUploader/AttachmentUploaderUpdater.tsx
function AttachmentUploaderUpdater({
  assignees,
  isConfidential,
  attachmentId,
  refId,
  setErrors,
  setAssignees,
  setIsConfidential
}) {
  const {
    updateAttachment
  } = useUpdateAttachment();
  const {
    t
  } = useUikitTranslation("AttachmentUploader");
  const handleUpdateAttachment = (nextAssignees, nextIsConfidential) => {
    if (attachmentId) {
      updateAttachment({
        input: {
          attachmentId,
          confidential: nextIsConfidential,
          assignees: nextIsConfidential ? normalizedAssignees(nextAssignees) : []
        },
        refId,
        onCompleted(data) {
          const {
            updateAttachment: updateAttachment2
          } = data;
          if (updateAttachment2?.errors && updateAttachment2?.errors.length > 0) {
            console.error(updateAttachment2?.errors);
            setErrors(updateAttachment2?.errors);
          }
        },
        onError(err) {
          console.log(err);
        }
      });
    }
  };
  const handlePick = nextAssignees => {
    setAssignees(nextAssignees);
    handleUpdateAttachment(nextAssignees, isConfidential);
  };
  const handleSetConfidential = nextIsConfidential => {
    setIsConfidential(nextIsConfidential);
    handleUpdateAttachment(assignees, nextIsConfidential);
  };
  return /* @__PURE__ */React4.createElement(Row2, null, /* @__PURE__ */React4.createElement(StackItem2, {
    width: "1/2"
  }, isConfidential && /* @__PURE__ */React4.createElement(AttachmentAssigneePicker, {
    onChange: handlePick,
    assignees
  })), /* @__PURE__ */React4.createElement(StackItem2, {
    width: "1/2"
  }, /* @__PURE__ */React4.createElement(Stack, {
    direction: "vertical",
    gap: "xs"
  }, /* @__PURE__ */React4.createElement(Heading, {
    size: "sm",
    color: "muted"
  }, t("permissions")), /* @__PURE__ */React4.createElement(Checkbox, {
    onChange: (_, nextVal) => handleSetConfidential(nextVal),
    value: isConfidential
  }, t("confidential")))));
}

// src/AttachmentUploader/AttachmentUploaderDisplayFile.tsx
import { Button, Progress, Stack as Stack2, StackItem as StackItem3, XIcon } from "@workflows/ui";
import * as React5 from "react";
import { humanFileSize } from "@workflows/std-js/string";
function DisplayFile({
  attachment,
  progress,
  handleReject,
  fileState
}) {
  const fileName = fileState?.name || attachment?.name;
  const fileSize = humanFileSize(fileState?.size ?? attachment?.contentLength, true);
  return /* @__PURE__ */React5.createElement(Stack2, {
    direction: "horizontal",
    gap: "xs",
    align: "center",
    className: "py-xs",
    key: fileName
  }, /* @__PURE__ */React5.createElement(StackItem3, {
    grow: 1
  }, fileName.substr(0, fileName.lastIndexOf(".")) || fileName), fileState && /* @__PURE__ */React5.createElement(Progress, {
    max: 100,
    value: progress,
    size: "xs"
  }), /* @__PURE__ */React5.createElement(StackItem3, null, fileSize), fileState && progress < 100 && /* @__PURE__ */React5.createElement(Button, {
    minimal: true,
    size: "sm",
    onClick: handleReject
  }, /* @__PURE__ */React5.createElement(XIcon, null)));
}

// src/AttachmentUploader/AnonymousAttachmentUploader.tsx
function AnonymousAttachmentUploader({
  className,
  label,
  refId,
  onClose,
  onUpload,
  attachment,
  canUpdate,
  code,
  ...props
}) {
  const {
    t
  } = useUikitTranslation("AttachmentUploader");
  const data = useFragment3(AssigneesPreview__node, attachment);
  const attachmentAssignees = getEdgeNodes3(data?.assignees);
  const mappedAssignees = attachmentAssignees.map(assignee => ({
    roleId: "ai.workflows.roles.role:assignee",
    userId: assignee.actor.id
  }));
  const {
    userId
  } = useViewerTenant3(true);
  const defaultAssignees = [{
    roleId: "ai.workflows.roles.role:assignee",
    userId
  }];
  const [fileState, setFileState] = React6.useState();
  const [errors, setErrors] = React6.useState([]);
  const [progress, setProgress] = React6.useState(0);
  const [isConfidential, setIsConfidential] = React6.useState(attachment?.confidential ?? false);
  const [assignees, setAssignees] = React6.useState(mappedAssignees.length > 0 ? mappedAssignees : defaultAssignees);
  const [attachmentId, setAttachmentId] = React6.useState(attachment?.id);
  const abortControllerRef = React6.useRef();
  const handleReject = () => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
  };
  return /* @__PURE__ */React6.createElement("div", {
    className: classNames([className, "file-input"])
  }, !!label && /* @__PURE__ */React6.createElement(Label, {
    required: props.required
  }, label), /* @__PURE__ */React6.createElement(Stack3, {
    gap: "md",
    direction: "vertical"
  }, /* @__PURE__ */React6.createElement(UploadErrors, {
    errors
  }), canUpdate && /* @__PURE__ */React6.createElement(AttachmentUploaderUpdater, {
    assignees,
    isConfidential,
    attachmentId,
    refId,
    setErrors,
    setAssignees,
    setIsConfidential
  }), !fileState && !attachment && /* @__PURE__ */React6.createElement(AnonymousAttachmentInput, {
    refId,
    onUpload,
    isConfidential,
    assignees,
    abortControllerRef,
    code,
    setErrors,
    setFileState,
    setAttachmentId,
    setProgress
  }), (fileState || attachment) && /* @__PURE__ */React6.createElement(DisplayFile, {
    progress,
    handleReject,
    fileState,
    attachment
  }), !attachment && /* @__PURE__ */React6.createElement(StackItem4, null, t("hint")), /* @__PURE__ */React6.createElement(Stack3, {
    direction: "horizontal",
    grow: 1,
    justify: "end"
  }, /* @__PURE__ */React6.createElement(Button2, {
    onClick: onClose
  }, t("actions.close")))));
}
function UploadErrors({
  errors
}) {
  const {
    t
  } = useUikitTranslation("AttachmentUploader");
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, errors.length > 0 && errors.map(error => /* @__PURE__ */React6.createElement(Callout, {
    intent: "critical",
    key: error.code
  }, t(`error.${error.code}`, t("error.unspecific")))));
}

// src/AttachmentUploader/AttachmentName.tsx
import { Editable, Row as Row3 } from "@workflows/ui";
import * as React7 from "react";
function AttachmentName({
  attachment,
  refId
}) {
  const fileExts = attachment.name.split(".").pop();
  const fileName = attachment.name.substr(0, attachment.name.lastIndexOf(".")) || attachment.name;
  const {
    updateAttachment
  } = useUpdateAttachment();
  const handleAttachmentNameChange = newName => {
    updateAttachment({
      input: {
        attachmentId: attachment.id,
        name: fileExts ? `${newName}.${fileExts}` : newName,
        confidential: attachment.confidential
      },
      refId,
      onError(error) {
        console.error(error);
      },
      onCompleted(data) {
        if (data.updateAttachment?.errors) {
          console.error(data.updateAttachment.errors);
        }
      }
    });
  };
  return /* @__PURE__ */React7.createElement(Editable.Context, null, /* @__PURE__ */React7.createElement(Row3, {
    align: "baseline",
    gap: "xl"
  }, /* @__PURE__ */React7.createElement(Editable.SingleLineEditor, {
    placeholderText: "Attachment Name",
    onChange: handleAttachmentNameChange
  }, /* @__PURE__ */React7.createElement("div", null, fileName || attachment.name)), /* @__PURE__ */React7.createElement(Editable.Trigger, null, /* @__PURE__ */React7.createElement(Editable.EditButton, {
    variant: "icon"
  }))));
}

// src/AttachmentUploader/AttachmentUploader.tsx
import { classNames as classNames2, getEdgeNodes as getEdgeNodes4, useFragment as useFragment4 } from "@workflows/runtime-web";
import { Button as Button3, Callout as Callout2, Label as Label2, Stack as Stack4, StackItem as StackItem5, useViewerTenant as useViewerTenant5 } from "@workflows/ui";
import * as React9 from "react";

// src/AttachmentUploader/hooks/__generated__/useUploadAttachmentMutation.graphql.ts
var node7 = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "connections"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadUrl",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientMutationId",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentLength",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confidential",
      "storageKey": null
    },
    v10 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v11 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "insertedAt",
      "storageKey": null
    },
    v12 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    v13 = [v6],
    v14 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v15 = {
      "kind": "InlineFragment",
      "selections": [v6, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textColor",
        "storageKey": null
      }],
      "type": "_Status",
      "abstractKey": null
    },
    v16 = [v14, {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "actor",
        "plural": false,
        "selections": v13,
        "storageKey": null
      }],
      "type": "_Assignee",
      "abstractKey": null
    }, v15],
    v17 = [{
      "kind": "Literal",
      "name": "first",
      "value": 100
    }],
    v18 = [v14, {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "actor",
        "plural": false,
        "selections": [v14, v6, v5],
        "storageKey": null
      }],
      "type": "_Assignee",
      "abstractKey": null
    }, v15, v5];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useUploadAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v1,
        "concreteType": "UploadAttachmentPayload",
        "kind": "LinkedField",
        "name": "uploadAttachment",
        "plural": false,
        "selections": [v2, v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, v8, v3, v9, {
            "alias": null,
            "args": null,
            "concreteType": "_User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [v10],
            "storageKey": null
          }, {
            "args": [{
              "kind": "Literal",
              "name": "count",
              "value": 100
            }],
            "kind": "FragmentSpread",
            "name": "AssigneesPreview__node"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "refObject",
          "plural": false,
          "selections": [{
            "kind": "InlineFragment",
            "selections": [v5, {
              "alias": null,
              "args": null,
              "concreteType": "_ActivityConnectionType",
              "kind": "LinkedField",
              "name": "_activities",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_ActivityConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Activity",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, v11, v12, {
                    "alias": null,
                    "args": null,
                    "concreteType": "_User",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": v13,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fromObject",
                    "plural": false,
                    "selections": v16,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "toObject",
                    "plural": false,
                    "selections": v16,
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "type": "_Matter",
            "abstractKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useUploadAttachmentMutation",
      "selections": [{
        "alias": null,
        "args": v1,
        "concreteType": "UploadAttachmentPayload",
        "kind": "LinkedField",
        "name": "uploadAttachment",
        "plural": false,
        "selections": [v2, v3, v4, {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "attachment",
          "plural": false,
          "selections": [v5, v6, v7, v8, v3, v9, {
            "alias": null,
            "args": null,
            "concreteType": "_User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [v10, v5],
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": "assignees",
              "args": v17,
              "concreteType": "_AssigneeConnection",
              "kind": "LinkedField",
              "name": "_assignees",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_AssigneeConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Assignee",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [v14, v5, v6],
                    "storageKey": null
                  }, v14],
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }, {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": "_assignees(first:100)"
            }, {
              "alias": "assignees",
              "args": v17,
              "filters": null,
              "handle": "connection",
              "key": "AssigneesPreview__assignees",
              "kind": "LinkedHandle",
              "name": "_assignees"
            }],
            "type": "_HasAssignees",
            "abstractKey": "__is_HasAssignees"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "filters": null,
          "handle": "appendNode",
          "key": "",
          "kind": "LinkedHandle",
          "name": "attachment",
          "handleArgs": [{
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }, {
            "kind": "Literal",
            "name": "edgeTypeName",
            "value": "AttachmentConnectionEdge"
          }]
        }, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "refObject",
          "plural": false,
          "selections": [v14, v5, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "_ActivityConnectionType",
              "kind": "LinkedField",
              "name": "_activities",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "_ActivityConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "_Activity",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v5, v11, v12, {
                    "alias": null,
                    "args": null,
                    "concreteType": "_User",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [v6, v5],
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fromObject",
                    "plural": false,
                    "selections": v18,
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "toObject",
                    "plural": false,
                    "selections": v18,
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "type": "_Matter",
            "abstractKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "f567a782924f69860b13e184de61f143",
      "id": null,
      "metadata": {},
      "name": "useUploadAttachmentMutation",
      "operationKind": "mutation",
      "text": "mutation useUploadAttachmentMutation(\n  $input: UploadAttachmentInput!\n) {\n  uploadAttachment(input: $input) {\n    errors {\n      code\n      message\n      type\n    }\n    uploadUrl\n    clientMutationId\n    attachment {\n      id\n      name\n      contentLength\n      downloadUrl\n      uploadUrl\n      confidential\n      creator {\n        displayName\n        id\n      }\n      ...AssigneesPreview__node_2ON54F\n    }\n    refObject {\n      __typename\n      ... on _Matter {\n        id\n        _activities {\n          edges {\n            node {\n              id\n              insertedAt\n              identifier\n              actor {\n                name\n                id\n              }\n              fromObject {\n                __typename\n                ... on _Assignee {\n                  actor {\n                    __typename\n                    name\n                    id\n                  }\n                }\n                ... on _Status {\n                  name\n                  color\n                  textColor\n                }\n                id\n              }\n              toObject {\n                __typename\n                ... on _Assignee {\n                  actor {\n                    __typename\n                    name\n                    id\n                  }\n                }\n                ... on _Status {\n                  name\n                  color\n                  textColor\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AssigneesPreview__node_2ON54F on _HasAssignees {\n  __is_HasAssignees: __typename\n  assignees: _assignees(first: 100) {\n    edges {\n      node {\n        id\n        actor {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "421b4e7ab7ed073b522ed0935fee7348";
var useUploadAttachmentMutation_graphql_default = node7;

// src/AttachmentUploader/hooks/useUploadAttachment.tsx
import { ConnectionHandler as ConnectionHandler3, newId as newId3, useMutation as useMutation3 } from "@workflows/runtime-web";
import { useViewerTenant as useViewerTenant4 } from "@workflows/ui";
function useUploadAttachment() {
  const {
    tenantId
  } = useViewerTenant4(true);
  const [mutation] = useMutation3(uploadAttachmentMutation);
  const uploadAttachment = props => {
    const {
      onError,
      onCompleted,
      input: {
        refId,
        contentLength,
        name,
        confidential,
        assignees,
        attachmentId
      }
    } = props;
    const connectionID = ConnectionHandler3.getConnectionID(refId, "useAttachmentsFragment_attachments");
    mutation({
      variables: {
        input: {
          clientMutationId: newId3(),
          refId,
          contentLength,
          name,
          tenantId,
          confidential,
          assignees,
          attachmentId
        },
        connections: [connectionID]
      },
      onCompleted,
      onError
    });
  };
  return {
    uploadAttachment
  };
}
var uploadAttachmentMutation = (useUploadAttachmentMutation_graphql_default.hash && useUploadAttachmentMutation_graphql_default.hash !== "421b4e7ab7ed073b522ed0935fee7348" && console.error("The definition of 'useUploadAttachmentMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useUploadAttachmentMutation_graphql_default);

// src/AttachmentUploader/AttachmentUploaderInput.tsx
import axios2 from "axios";
import { AttachmentInput as AttachmentInput2 } from "@workflows/ui";
import * as React8 from "react";
function AttachmentUploaderInput({
  refId,
  onUpload,
  isConfidential,
  assignees,
  setErrors,
  setFileState,
  setAttachmentId,
  setProgress,
  abortControllerRef
}) {
  const {
    uploadAttachment
  } = useUploadAttachment();
  const handleChange = file => {
    setErrors([]);
    if (!file) {
      return;
    }
    uploadAttachment({
      input: {
        refId,
        name: file.name,
        contentLength: file.size,
        confidential: isConfidential,
        assignees: isConfidential ? normalizedAssignees(assignees) : []
      },
      onCompleted(data) {
        const {
          uploadAttachment: uploadAttachment2
        } = data;
        if (uploadAttachment2?.errors && uploadAttachment2?.errors.length > 0) {
          console.error(uploadAttachment2?.errors);
          setErrors(uploadAttachment2?.errors);
          setFileState(void 0);
        }
        if (!uploadAttachment2?.uploadUrl) {
          return;
        }
        setAttachmentId(uploadAttachment2?.attachment?.id);
        abortControllerRef.current = new AbortController();
        axios2.put(uploadAttachment2.uploadUrl, file, {
          headers: {
            "Content-Type": file.type
          },
          onUploadProgress: progressEvent => {
            const {
              loaded,
              total = 1
            } = progressEvent;
            const percentage = Math.floor(loaded * 100 / total);
            setProgress(percentage);
          },
          signal: abortControllerRef.current?.signal
        }).catch(error => {
          if (error.code === "ERR_CANCELED") {
            setFileState(void 0);
          } else {
            console.log(error);
          }
        });
        setFileState({
          name: file.name,
          size: file.size
        });
        onUpload?.(file);
      },
      onError(err) {
        console.log(err);
      }
    });
  };
  return /* @__PURE__ */React8.createElement(AttachmentInput2, {
    onChange: handleChange
  });
}

// src/AttachmentUploader/AttachmentUploader.tsx
function AttachmentUploader({
  className,
  label,
  refId,
  onClose,
  onUpload,
  attachment,
  canUpdate,
  ...props
}) {
  const {
    t
  } = useUikitTranslation("AttachmentUploader");
  const data = useFragment4(AssigneesPreview__node, attachment);
  const attachmentAssignees = getEdgeNodes4(data?.assignees);
  const mappedAssignees = attachmentAssignees.map(assignee => ({
    roleId: "ai.workflows.roles.role:assignee",
    userId: assignee.actor.id
  }));
  const {
    userId
  } = useViewerTenant5(true);
  const defaultAssignees = [{
    roleId: "ai.workflows.roles.role:assignee",
    userId
  }];
  const [fileState, setFileState] = React9.useState();
  const [errors, setErrors] = React9.useState([]);
  const [progress, setProgress] = React9.useState(0);
  const [isConfidential, setIsConfidential] = React9.useState(attachment?.confidential ?? canUpdate);
  const [assignees, setAssignees] = React9.useState(mappedAssignees.length > 0 ? mappedAssignees : defaultAssignees);
  const [attachmentId, setAttachmentId] = React9.useState(attachment?.id);
  const abortControllerRef = React9.useRef();
  const handleReject = () => {
    if (abortControllerRef.current) abortControllerRef.current.abort();
  };
  return /* @__PURE__ */React9.createElement("div", {
    className: classNames2([className, "file-input"])
  }, !!label && /* @__PURE__ */React9.createElement(Label2, {
    required: props.required
  }, label), /* @__PURE__ */React9.createElement(Stack4, {
    gap: "md",
    direction: "vertical"
  }, errors.length > 0 && errors.map(error => /* @__PURE__ */React9.createElement(Callout2, {
    intent: "critical",
    key: error.code
  }, t(`error.${error.code}`, t("error.unspecific")))), canUpdate && /* @__PURE__ */React9.createElement(AttachmentUploaderUpdater, {
    assignees,
    isConfidential,
    attachmentId,
    refId,
    setErrors,
    setAssignees,
    setIsConfidential
  }), !fileState && !attachment && /* @__PURE__ */React9.createElement(AttachmentUploaderInput, {
    refId,
    onUpload,
    isConfidential,
    assignees,
    abortControllerRef,
    setErrors,
    setFileState,
    setAttachmentId,
    setProgress
  }), (fileState || attachment) && /* @__PURE__ */React9.createElement(DisplayFile, {
    progress,
    handleReject,
    fileState,
    attachment
  }), !attachment && /* @__PURE__ */React9.createElement(StackItem5, null, t("hint")), onClose && /* @__PURE__ */React9.createElement(Stack4, {
    direction: "horizontal",
    grow: 1,
    justify: "end"
  }, /* @__PURE__ */React9.createElement(Button3, {
    onClick: onClose
  }, t("actions.close")))));
}
var normalizedAssignees = assignees => assignees.map(({
  userId,
  roleId
}) => ({
  assigneeId: userId,
  roleIdentifier: roleId
}));

// src/TaskRefTableView/index.tsx
import * as React10 from "react";
function TaskRefTableView() {
  return /* @__PURE__ */React10.createElement("div", null, "TaskRefTableView");
}

// src/Properties/index.tsx
import * as React18 from "react";

// src/Properties/PropertyText.tsx
import * as React12 from "react";
import { TextField } from "@workflows/ui";

// src/Properties/PropertyContainer.tsx
import * as React11 from "react";
import { Property, StackItem as StackItem6 } from "@workflows/ui";
var PropertyContainer = ({
  title,
  name,
  readonly,
  renderEditor,
  renderViewer
}) => {
  const {
    value,
    onChange
  } = React11.useContext(PropertyContext);
  const [currentValue, setCurrentValue] = React11.useState(value[name]);
  const handleClose = () => {
    onChange({
      [name]: currentValue
    });
  };
  const Editor = renderEditor;
  if (typeof currentValue === "undefined") {
    console.warn("Properties: Could not find value:", name);
  }
  return currentValue ? /* @__PURE__ */React11.createElement(StackItem6, {
    width: "full",
    className: "mb--md"
  }, /* @__PURE__ */React11.createElement(Property, {
    title,
    value: currentValue,
    renderViewer: props => /* @__PURE__ */React11.createElement("div", null, renderViewer ? renderViewer(props?.value) : props?.value || "-"),
    onClose: handleClose,
    renderEditor: readonly ? void 0 : () => /* @__PURE__ */React11.createElement(Editor, {
      value: currentValue,
      onChange: val => setCurrentValue(val)
    })
  })) : null;
};

// src/Properties/PropertyText.tsx
var PropertyText = ({
  title,
  name,
  readonly
}) => {
  return /* @__PURE__ */React12.createElement(PropertyContainer, {
    title,
    name,
    renderEditor: PropertyTextEditor,
    readonly
  });
};
var PropertyTextEditor = props => {
  return /* @__PURE__ */React12.createElement(TextField, {
    ...props
  });
};

// src/Properties/PropertyRow.tsx
import { Stack as Stack5 } from "@workflows/ui";
import * as React13 from "react";
var PropertyRow = ({
  children
}) => {
  return /* @__PURE__ */React13.createElement(Stack5, {
    direction: "horizontal"
  }, children);
};

// src/Properties/PropertyTextarea.tsx
import { TextArea } from "@workflows/ui";
import * as React14 from "react";
var PropertyTextarea = ({
  title,
  name,
  readonly
}) => {
  return /* @__PURE__ */React14.createElement(PropertyContainer, {
    title,
    name,
    renderEditor: PropertyTextEditor2,
    readonly
  });
};
var PropertyTextEditor2 = props => {
  return /* @__PURE__ */React14.createElement(TextArea, {
    ...props
  });
};

// src/Properties/PropertyDate.tsx
import { DatePicker } from "@workflows/ui";
import * as React15 from "react";
var PropertyDate = ({
  title,
  name,
  readonly
}) => {
  const renderViewer = value => {
    return new Date(value).toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  };
  return /* @__PURE__ */React15.createElement(PropertyContainer, {
    title,
    name,
    renderEditor: PropertyDateEditor,
    renderViewer,
    readonly
  });
};
var PropertyDateEditor = props => {
  const {
    value = "",
    onChange
  } = props;
  const date = new Date(value);
  return /* @__PURE__ */React15.createElement(DatePicker, {
    value: date,
    onChange
  });
};

// src/Properties/PropertySelect.tsx
import { Select } from "@workflows/ui";
import * as React16 from "react";
var PropertySelect = ({
  title,
  name,
  readonly,
  options
}) => {
  const renderViewer = value => {
    return options.find(option => option.value === value)?.label || "-";
  };
  return /* @__PURE__ */React16.createElement(PropertyContainer, {
    title,
    name,
    renderEditor: props => /* @__PURE__ */React16.createElement(PropertySelectEditor, {
      ...props,
      options
    }),
    renderViewer,
    readonly
  });
};
var PropertySelectEditor = props => {
  const {
    value = "",
    onChange,
    options
  } = props;
  const handleChange = (_, value2) => {
    onChange?.(value2);
  };
  return /* @__PURE__ */React16.createElement(Select, {
    defaultValue: value,
    onChange: handleChange,
    options
  });
};

// src/Properties/PropertyTreeSelect.tsx
import * as React17 from "react";
import { TreeSelect } from "@workflows/ui";
var PropertyTreeSelect = ({
  title,
  name,
  readonly,
  options
}) => {
  const renderViewer = value => {
    return typeof value === "string" ? value : value[value.length - 1].label;
  };
  return /* @__PURE__ */React17.createElement(PropertyContainer, {
    title,
    name,
    renderEditor: props => /* @__PURE__ */React17.createElement(TreeSelect, {
      ...props,
      options
    }),
    renderViewer,
    readonly
  });
};

// src/Properties/index.tsx
var Properties = ({
  children,
  value,
  onChange
}) => {
  return /* @__PURE__ */React18.createElement(PropertyContext.Provider, {
    value: {
      value,
      onChange
    }
  }, children);
};
var PropertyContext = React18.createContext({});
Properties.Text = PropertyText;
Properties.Row = PropertyRow;
Properties.Textarea = PropertyTextarea;
Properties.Date = PropertyDate;
Properties.Select = PropertySelect;
Properties.TreeSelect = PropertyTreeSelect;

// src/Status/__generated__/Status__status.graphql.ts
var node8 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Status__status",
  "selections": [{
    "alias": "status",
    "args": null,
    "concreteType": "_Status",
    "kind": "LinkedField",
    "name": "_status",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textColor",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "_HasStatus",
  "abstractKey": "__is_HasStatus"
};
node8.hash = "18d482dffc5ef1a1cfedbf580b5d5386";
var Status_status_graphql_default = node8;

// src/Status/__generated__/Status_status.graphql.ts
var node9 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Status_status",
  "selections": [{
    "alias": null,
    "args": null,
    "concreteType": "Status",
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textColor",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "HasStatus",
  "abstractKey": "__isHasStatus"
};
node9.hash = "208ffc4b16651c9479fa47ec88d78fc4";
var Status_status_graphql_default2 = node9;

// src/Status/index.tsx
import { useFragment as useFragment5 } from "@workflows/runtime-web";
import * as React19 from "react";
import { Status as CoreStatus } from "@workflows/ui";
function Status({
  className,
  size,
  status,
  compat = false,
  indicator = false
}) {
  const data = useFragment5(compat ? Status__status : Status_status, status || null);
  return /* @__PURE__ */React19.createElement(CoreStatus, {
    size,
    color: data?.status?.color,
    className,
    name: data?.status?.name || "",
    textColor: data?.status?.textColor,
    indicator
  });
}
var Status_status = (Status_status_graphql_default2.hash && Status_status_graphql_default2.hash !== "208ffc4b16651c9479fa47ec88d78fc4" && console.error("The definition of 'Status_status' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), Status_status_graphql_default2);
var Status__status = (Status_status_graphql_default.hash && Status_status_graphql_default.hash !== "18d482dffc5ef1a1cfedbf580b5d5386" && console.error("The definition of 'Status__status' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), Status_status_graphql_default);

// src/StatusPicker/index.tsx
var StatusPicker_exports = {};
__export(StatusPicker_exports, {
  Overlay: () => Overlay,
  QueryList: () => QueryList,
  Root: () => Root,
  Trigger: () => Trigger
});

// src/StatusPicker/StatusPickerOverlay.tsx
import * as React21 from "react";

// src/StatusPicker/StatusPickerRoot.tsx
import * as React20 from "react";
var StatusPickerContext = React20.createContext(void 0);
function StatusPickerRoot({
  children
}) {
  const [isVisible, setVisibility] = React20.useState(false);
  const toggleVisibility = () => {
    setVisibility(!isVisible);
  };
  const triggerRef = React20.useRef(null);
  return /* @__PURE__ */React20.createElement(StatusPickerContext.Provider, {
    value: {
      isVisible,
      toggleVisibility,
      triggerRef
    }
  }, children);
}

// src/StatusPicker/StatusPickerOverlay.tsx
import { Popover } from "@workflows/ui";
function StatusPickerOverlay({
  children,
  showPopoverHeader,
  title
}) {
  const context = React21.useContext(StatusPickerContext);
  return /* @__PURE__ */React21.createElement(Popover, {
    mode: "hover",
    placement: "bottom-start",
    title,
    header: null,
    showHeader: showPopoverHeader,
    targetRef: context?.triggerRef,
    isOpen: context?.isVisible || false,
    onInteraction: event => {
      event.stopPropagation();
      context?.toggleVisibility();
    }
  }, children);
}

// src/StatusPicker/StatusPickerQueryList.tsx
import * as React23 from "react";
import { useContext as useContext3 } from "react";
import { Stack as Stack7 } from "@workflows/ui";

// src/StatusPicker/StatusPickerItem.tsx
import * as React22 from "react";
import { Badge, Button as Button4, Stack as Stack6, Text as Text2 } from "@workflows/ui";
function StatusPickerItem({
  status,
  onClick
}) {
  return /* @__PURE__ */React22.createElement(Button4, {
    onClick: e => onClick(e, status?.identifier),
    minimal: true
  }, /* @__PURE__ */React22.createElement(Stack6, {
    direction: "horizontal",
    gap: "xs",
    justify: "baseline"
  }, /* @__PURE__ */React22.createElement(Stack6, {
    direction: "vertical",
    justify: "center"
  }, /* @__PURE__ */React22.createElement(Badge, {
    circle: true,
    color: status?.color
  })), /* @__PURE__ */React22.createElement(Text2, null, status?.name)));
}

// src/StatusPicker/hooks/__generated__/useAssignableStatusesQuery.graphql.ts
var node10 = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "typeIdentifier"
    }],
    v1 = [{
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }, {
        "kind": "Variable",
        "name": "typeIdentifier",
        "variableName": "typeIdentifier"
      }],
      "concreteType": "StatusConnection",
      "kind": "LinkedField",
      "name": "_assignableStatuses",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "StatusEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "Status",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "identifier",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textColor",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useAssignableStatusesQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useAssignableStatusesQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "78ac8f97e409a35f2ae73a417eeced31",
      "id": null,
      "metadata": {},
      "name": "useAssignableStatusesQuery",
      "operationKind": "query",
      "text": "query useAssignableStatusesQuery(\n  $tenantId: ID!\n  $typeIdentifier: String!\n) {\n  _assignableStatuses(tenantId: $tenantId, typeIdentifier: $typeIdentifier) {\n    edges {\n      node {\n        id\n        color\n        description\n        identifier\n        name\n        textColor\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "99ccfdbe002bb47943359dae13ab5000";
var useAssignableStatusesQuery_graphql_default = node10;

// src/StatusPicker/hooks/useAssignableStatuses.tsx
import { getEdgeNodes as getEdgeNodes5, useLazyLoadQuery as useLazyLoadQuery2 } from "@workflows/runtime-web";
import { useTenantId as useTenantId2 } from "@workflows/ui";
var useAssignableStatuses = (typeIdentifier = "ai.workflows.matters.matter") => {
  const tenantId = useTenantId2();
  const {
    _assignableStatuses
  } = useLazyLoadQuery2(_assignableStatusesQuery, {
    tenantId,
    typeIdentifier
  });
  return getEdgeNodes5(_assignableStatuses || null);
};
var _assignableStatusesQuery = (useAssignableStatusesQuery_graphql_default.hash && useAssignableStatusesQuery_graphql_default.hash !== "99ccfdbe002bb47943359dae13ab5000" && console.error("The definition of 'useAssignableStatusesQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), useAssignableStatusesQuery_graphql_default);

// src/StatusPicker/StatusPickerQueryList.tsx
function StatusPickerQueryList({
  value,
  onChange,
  typeIdentifier
}) {
  const statuses = useAssignableStatuses(typeIdentifier);
  const filteredStatuses = statuses?.filter(status => status.identifier !== value);
  const context = useContext3(StatusPickerContext);
  const handleSelect = (e, identifier) => {
    e.stopPropagation();
    onChange(identifier || "");
    context?.toggleVisibility();
  };
  return /* @__PURE__ */React23.createElement(Stack7, {
    direction: "vertical",
    gap: "xs",
    className: "py--xs"
  }, filteredStatuses?.map(status => /* @__PURE__ */React23.createElement(StatusPickerItem, {
    status,
    onClick: handleSelect,
    key: status.id
  })));
}

// src/StatusPicker/StatusPickerTrigger.tsx
import * as React24 from "react";
import { classNames as classNames3 } from "@workflows/runtime-web";
function StatusPickerTrigger({
  children
}) {
  const context = React24.useContext(StatusPickerContext);
  return /* @__PURE__ */React24.createElement("div", null, /* @__PURE__ */React24.createElement("span", {
    onClick: context?.toggleVisibility,
    ref: context?.triggerRef,
    className: classNames3(["cursor--pointer", "display--inline-block"])
  }, children));
}

// src/StatusPicker/index.tsx
var Overlay = StatusPickerOverlay;
var Root = StatusPickerRoot;
var QueryList = StatusPickerQueryList;
var Trigger = StatusPickerTrigger;

// src/Tags/__generated__/Tags_tags.graphql.ts
var node11 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tags_tags",
  "selections": [{
    "alias": null,
    "args": null,
    "concreteType": "_TagConnection",
    "kind": "LinkedField",
    "name": "tags",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "_TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "_Tag",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleText",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textColor",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "_HasTags",
  "abstractKey": "__is_HasTags"
};
node11.hash = "912d8098fced49cb8721a2da5fa2a36c";
var Tags_tags_graphql_default = node11;

// src/Tags/index.tsx
import * as React25 from "react";
import { getEdgeNodes as getEdgeNodes6, useFragment as useFragment6 } from "@workflows/runtime-web";
import { Tag as CoreTag } from "@workflows/ui";
function Tags({
  tags
}) {
  const data = useFragment6(Tags_tags, tags);
  const tagsNodes = getEdgeNodes6(data?.tags || null);
  return /* @__PURE__ */React25.createElement(React25.Fragment, null, tagsNodes.map(tag => /* @__PURE__ */React25.createElement(CoreTag, {
    key: tag.id,
    color: "#" + tag.color,
    textColor: "#" + tag.textColor
  }, tag.titleText)));
}
var Tags_tags = (Tags_tags_graphql_default.hash && Tags_tags_graphql_default.hash !== "912d8098fced49cb8721a2da5fa2a36c" && console.error("The definition of 'Tags_tags' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), Tags_tags_graphql_default);
export { AnonymousAttachmentUploader, AssigneesPreview, AssigneesPreview__node, AssigneesPreview_node, AttachmentAssigneePicker, AttachmentName, AttachmentUploader, Properties, PropertyContext, Status, StatusPicker_exports as StatusPicker, Status__status, Status_status, Tags, Tags_tags, TaskRefTableView, filterAssignablesWithoutName, normalizedAssignees, uikitI18nInstance, useAssignables, useAssignablesFragment };